export default __webpack_public_path__ + "static/media/bg_1.5249c6f3.jpg";